var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#DD353F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.184 17.147l14.085 9.568a3.973 3.973 0 0 0 4.462 0l14.085-9.568V1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.546 13.8A3.516 3.516 0 0 0 1 16.727v20.784C1 39.439 2.518 41 4.391 41H36.61C38.48 41 40 39.439 40 37.51V16.728a3.518 3.518 0 0 0-1.548-2.927M4.184 37l10.347-8.8M36.816 37L26.47 28.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.184 17v-5.333L14.489 1h22.327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.184 11.4H14.53V1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MSIgaGVpZ2h0PSI0MiIgdmlld0JveD0iMCAwIDQxIDQyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjREQzNTNGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxwYXRoIGQ9Ik00LjE4NCAxNy4xNDdsMTQuMDg1IDkuNTY4YTMuOTczIDMuOTczIDAgMCAwIDQuNDYyIDBsMTQuMDg1LTkuNTY4VjEuOCIvPgogICAgICAgIDxwYXRoIGQ9Ik0yLjU0NiAxMy44QTMuNTE2IDMuNTE2IDAgMCAwIDEgMTYuNzI3djIwLjc4NEMxIDM5LjQzOSAyLjUxOCA0MSA0LjM5MSA0MUgzNi42MUMzOC40OCA0MSA0MCAzOS40MzkgNDAgMzcuNTFWMTYuNzI4YTMuNTE4IDMuNTE4IDAgMCAwLTEuNTQ4LTIuOTI3TTQuMTg0IDM3bDEwLjM0Ny04LjhNMzYuODE2IDM3TDI2LjQ3IDI4LjIiLz4KICAgICAgICA8cGF0aCBkPSJNNC4xODQgMTd2LTUuMzMzTDE0LjQ4OSAxaDIyLjMyNyIvPgogICAgICAgIDxwYXRoIGQ9Ik00LjE4NCAxMS40SDE0LjUzVjEiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };